module.exports = __webpack_public_path__ + "img/1458238386.1bfcfbe4.jpg";